import { useEffect, useState, useCallback } from "react";

import { api_without_cancellation } from "../../../../api/api";
import { getCaseId, getClientId } from "../../../../Utils/helper";

export const useReports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isReportTaken, setIsReportTaken] = useState(false);
  const [showReportTakenField, setShowReportTakeField] = useState(true);
  const clientId = getClientId();
  const currentCaseId = getCaseId();

  const fetchReports = useCallback(async () => {
    // Don't fetch if required params are missing
    if (!clientId || !currentCaseId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await api_without_cancellation.get(
        `/api/reports/${clientId}/${currentCaseId}/`
      );

      if (response.status === 200) {
        setReports(response.data?.reports || []);
        const reportTaken = response.data?.reports?.some((report) => report.report_taken);
        setIsReportTaken(reportTaken);

        if (response.data.reports?.length >= 1) {
          setShowReportTakeField(false);
        }
      } else {
        const errorMessage = `Failed to fetch reports: ${response.status}`;
        setError(errorMessage);
        console.error(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "Failed to fetch reports";
      setError(errorMessage);
      console.error("Error fetching reports:", error);
      setReports([]); // Reset to empty array on error
    } finally {
      setLoading(false);
    }
  }, [clientId, currentCaseId]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  const refetch = useCallback(() => {
    fetchReports();
  }, [fetchReports]);

  return {
    reports,
    isReportTaken,
    showReportTakenField,
    loading,
    error,
    refetch,
  };
};
